export default "__VITE_ASSET__b6618019__"